export default {
  list: {
    id: "任务id",
    uid: "用户id",
    user: "用户",
    userName: "用户昵称",
    status: "状态",
    status_map: {
      1: "未联系",
      2: "无效电话",
      3: "已联系（无兴趣）",
      4: "已联系（感兴趣）",
      5: "已联系（挂断）",
    },
    platform: "平台",
    platform_map: {
      0: "全部",
      1: "ak777",
      2: "in11",
      3: "a11",
    },
    rechargeStatus: "充值状态",
    rechargeStatus_map: {
      0: "全部",
      1: "已复充",
      2: "未复充",
    },
    mobile: "手机号",
    recordId: "平台记录id",
    customerId: "客户id",
    handleAt: "处理时间",
    notes: "备注",
    loginAt: "登陆时间",
    rechargeAt: "复充时间",
    assignedAt: "分配时间",
    editStatus: "编辑状态",
    assignTasks: "分配任务",
    assignUser: "分配人",
    tips: "请选择任务，再分配～",
    code: "礼物码",
    claimedAt: "礼物码领取时间",
    mobileError: "手机号只能输入数字",
    giftAmount: "赠送金额",
  },
  config: {
    uid: "员工id",
    username: "员工昵称",
    num: "每天自动分配的号码数",
    todayCnt: "今日已分配号码数",
    autoAssign: "自动分配",
  },
};
